import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pause_circle",
  "use": "icon-pause_circle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-pause_circle\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path id=\"icon-pause_circle_形状\" class=\"cls-2\" d=\"M12,19a7,7,0,1,1,7-7A7,7,0,0,1,12,19ZM9.67,9.67v4.66h1.75V9.67Zm2.91,0v4.66h1.75V9.67Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol